import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, ContentChildren, Input, Output, NgModule } from '@angular/core';
import DxPieChart from 'devextreme/viz/pie_chart';
import * as i1 from 'devextreme-angular/core';
import { DxComponent, DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper, DxIntegrationModule, DxTemplateModule } from 'devextreme-angular/core';
import { DxoAdaptiveLayoutModule, DxoAnimationModule, DxiAnnotationModule, DxoBorderModule, DxoFontModule, DxoImageModule, DxoShadowModule, DxoCommonAnnotationSettingsModule, DxoCommonSeriesSettingsModule, DxoColorModule, DxoHoverStyleModule, DxoHatchingModule, DxoLabelModule, DxoArgumentFormatModule, DxoConnectorModule, DxoFormatModule, DxoSelectionStyleModule, DxoSmallValuesGroupingModule, DxoExportModule, DxoLegendModule, DxoMarginModule, DxoTitleModule, DxoSubtitleModule, DxoLoadingIndicatorModule, DxiSeriesModule, DxoSeriesTemplateModule, DxoSizeModule, DxoTooltipModule } from 'devextreme-angular/ui/nested';
import { DxoPieChartAdaptiveLayoutModule, DxoPieChartAnimationModule, DxiPieChartAnnotationModule, DxoPieChartAnnotationBorderModule, DxoPieChartArgumentFormatModule, DxoPieChartBorderModule, DxoPieChartColorModule, DxoPieChartCommonAnnotationSettingsModule, DxoPieChartCommonSeriesSettingsModule, DxoPieChartConnectorModule, DxoPieChartExportModule, DxoPieChartFontModule, DxoPieChartFormatModule, DxoPieChartHatchingModule, DxoPieChartHoverStyleModule, DxoPieChartImageModule, DxoPieChartLabelModule, DxoPieChartLegendModule, DxoPieChartLegendTitleModule, DxoPieChartLegendTitleSubtitleModule, DxoPieChartLoadingIndicatorModule, DxoPieChartMarginModule, DxoPieChartPieChartTitleModule, DxoPieChartPieChartTitleSubtitleModule, DxoPieChartSelectionStyleModule, DxiPieChartSeriesModule, DxoPieChartSeriesBorderModule, DxoPieChartSeriesTemplateModule, DxoPieChartShadowModule, DxoPieChartSizeModule, DxoPieChartSmallValuesGroupingModule, DxoPieChartSubtitleModule, DxoPieChartTitleModule, DxoPieChartTooltipModule, DxoPieChartTooltipBorderModule } from 'devextreme-angular/ui/pie-chart/nested';
export * from 'devextreme-angular/ui/pie-chart/nested';
import { PROPERTY_TOKEN_annotations, PROPERTY_TOKEN_series } from 'devextreme-angular/core/tokens';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/**
 * The PieChart is a UI component that visualizes data as a circle divided into sectors that each represents a portion of the whole.

 */
let DxPieChartComponent = /*#__PURE__*/(() => {
  class DxPieChartComponent extends DxComponent {
    _watcherHelper;
    _idh;
    set _annotationsContentChildren(value) {
      this.setChildren('annotations', value);
    }
    set _seriesContentChildren(value) {
      this.setChildren('series', value);
    }
    instance = null;
    /**
     * Specifies adaptive layout properties.
    
     */
    get adaptiveLayout() {
      return this._getOption('adaptiveLayout');
    }
    set adaptiveLayout(value) {
      this._setOption('adaptiveLayout', value);
    }
    /**
     * Specifies animation properties.
    
     */
    get animation() {
      return this._getOption('animation');
    }
    set animation(value) {
      this._setOption('animation', value);
    }
    /**
     * Specifies the annotation collection.
    
     */
    get annotations() {
      return this._getOption('annotations');
    }
    set annotations(value) {
      this._setOption('annotations', value);
    }
    /**
     * Specifies a custom template for content in the pie&apos;s center.
    
     */
    get centerTemplate() {
      return this._getOption('centerTemplate');
    }
    set centerTemplate(value) {
      this._setOption('centerTemplate', value);
    }
    /**
     * Specifies settings common for all annotations in the PieChart.
    
     */
    get commonAnnotationSettings() {
      return this._getOption('commonAnnotationSettings');
    }
    set commonAnnotationSettings(value) {
      this._setOption('commonAnnotationSettings', value);
    }
    /**
     * An object defining the configuration properties that are common for all series of the PieChart UI component.
    
     */
    get commonSeriesSettings() {
      return this._getOption('commonSeriesSettings');
    }
    set commonSeriesSettings(value) {
      this._setOption('commonSeriesSettings', value);
    }
    /**
     * Customizes an individual annotation.
    
     */
    get customizeAnnotation() {
      return this._getOption('customizeAnnotation');
    }
    set customizeAnnotation(value) {
      this._setOption('customizeAnnotation', value);
    }
    /**
     * Customizes the appearance of an individual point label.
    
     */
    get customizeLabel() {
      return this._getOption('customizeLabel');
    }
    set customizeLabel(value) {
      this._setOption('customizeLabel', value);
    }
    /**
     * Customizes the appearance of an individual series point.
    
     */
    get customizePoint() {
      return this._getOption('customizePoint');
    }
    set customizePoint(value) {
      this._setOption('customizePoint', value);
    }
    /**
     * Binds the UI component to data.
    
     */
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    /**
     * Specifies the diameter of the pie.
    
     */
    get diameter() {
      return this._getOption('diameter');
    }
    set diameter(value) {
      this._setOption('diameter', value);
    }
    /**
     * Specifies whether the UI component responds to user interaction.
    
     */
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    /**
     * Specifies the global attributes to be attached to the UI component&apos;s container element.
    
     */
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    /**
     * Configures the exporting and printing features.
    
     */
    get export() {
      return this._getOption('export');
    }
    set export(value) {
      this._setOption('export', value);
    }
    /**
     * Specifies the fraction of the inner radius relative to the total radius in the series of the &apos;doughnut&apos; type. The value should be between 0 and 1.
    
     */
    get innerRadius() {
      return this._getOption('innerRadius');
    }
    set innerRadius(value) {
      this._setOption('innerRadius', value);
    }
    /**
     * Specifies PieChart legend properties.
    
     */
    get legend() {
      return this._getOption('legend');
    }
    set legend(value) {
      this._setOption('legend', value);
    }
    /**
     * Configures the loading indicator.
    
     */
    get loadingIndicator() {
      return this._getOption('loadingIndicator');
    }
    set loadingIndicator(value) {
      this._setOption('loadingIndicator', value);
    }
    /**
     * Generates space around the UI component.
    
     */
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    /**
     * Specifies the minimum diameter of the pie.
    
     */
    get minDiameter() {
      return this._getOption('minDiameter');
    }
    set minDiameter(value) {
      this._setOption('minDiameter', value);
    }
    /**
     * Sets the palette to be used to colorize series and their elements.
    
     */
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    /**
     * Specifies what to do with colors in the palette when their number is less than the number of series (in the Chart UI component) or points in a series (in the PieChart UI component).
    
     */
    get paletteExtensionMode() {
      return this._getOption('paletteExtensionMode');
    }
    set paletteExtensionMode(value) {
      this._setOption('paletteExtensionMode', value);
    }
    /**
     * Notifies the UI component that it is embedded into an HTML page that uses a tag modifying the path.
    
     */
    get pathModified() {
      return this._getOption('pathModified');
    }
    set pathModified(value) {
      this._setOption('pathModified', value);
    }
    /**
     * Specifies whether a single point or multiple points can be selected in the chart.
    
     */
    get pointSelectionMode() {
      return this._getOption('pointSelectionMode');
    }
    set pointSelectionMode(value) {
      this._setOption('pointSelectionMode', value);
    }
    /**
     * Specifies whether to redraw the UI component when the size of the container changes or a mobile device rotates.
    
     */
    get redrawOnResize() {
      return this._getOption('redrawOnResize');
    }
    set redrawOnResize(value) {
      this._setOption('redrawOnResize', value);
    }
    /**
     * Specifies how a chart must behave when point labels overlap.
    
     */
    get resolveLabelOverlapping() {
      return this._getOption('resolveLabelOverlapping');
    }
    set resolveLabelOverlapping(value) {
      this._setOption('resolveLabelOverlapping', value);
    }
    /**
     * Switches the UI component to a right-to-left representation.
    
     */
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    /**
     * Specifies the direction that the pie chart segments will occupy.
    
     */
    get segmentsDirection() {
      return this._getOption('segmentsDirection');
    }
    set segmentsDirection(value) {
      this._setOption('segmentsDirection', value);
    }
    /**
     * Specifies properties for the series of the PieChart UI component.
    
     */
    get series() {
      return this._getOption('series');
    }
    set series(value) {
      this._setOption('series', value);
    }
    /**
     * Defines properties for the series template.
    
     */
    get seriesTemplate() {
      return this._getOption('seriesTemplate');
    }
    set seriesTemplate(value) {
      this._setOption('seriesTemplate', value);
    }
    /**
     * Specifies the UI component&apos;s size in pixels.
    
     */
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    /**
     * Allows you to display several adjoining pies in the same size.
    
     */
    get sizeGroup() {
      return this._getOption('sizeGroup');
    }
    set sizeGroup(value) {
      this._setOption('sizeGroup', value);
    }
    /**
     * Specifies the angle in arc degrees from which the first segment of a pie chart should start.
    
     */
    get startAngle() {
      return this._getOption('startAngle');
    }
    set startAngle(value) {
      this._setOption('startAngle', value);
    }
    /**
     * Sets the name of the theme the UI component uses.
    
     */
    get theme() {
      return this._getOption('theme');
    }
    set theme(value) {
      this._setOption('theme', value);
    }
    /**
     * Configures the UI component&apos;s title.
    
     */
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    /**
     * Configures tooltips.
    
     */
    get tooltip() {
      return this._getOption('tooltip');
    }
    set tooltip(value) {
      this._setOption('tooltip', value);
    }
    /**
     * Specifies the type of the pie chart series.
    
     */
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    /**
    
     * A function that is executed before the UI component is disposed of.
    
    
     */
    onDisposing;
    /**
    
     * A function that is executed when all series are ready.
    
    
     */
    onDone;
    /**
    
     * A function that is executed when the UI component&apos;s rendering has finished.
    
    
     */
    onDrawn;
    /**
    
     * A function that is executed after the UI component is exported.
    
    
     */
    onExported;
    /**
    
     * A function that is executed before the UI component is exported.
    
    
     */
    onExporting;
    /**
    
     * A function that is executed before a file with exported UI component is saved to the user&apos;s local storage.
    
    
     */
    onFileSaving;
    /**
    
     * A function that is executed when an error or warning occurs.
    
    
     */
    onIncidentOccurred;
    /**
    
     * A function used in JavaScript frameworks to save the UI component instance.
    
    
     */
    onInitialized;
    /**
    
     * A function that is executed when a legend item is clicked or tapped.
    
    
     */
    onLegendClick;
    /**
    
     * A function that is executed after a UI component property is changed.
    
    
     */
    onOptionChanged;
    /**
    
     * A function that is executed when a series point is clicked or tapped.
    
    
     */
    onPointClick;
    /**
    
     * A function that is executed after the pointer enters or leaves a series point.
    
    
     */
    onPointHoverChanged;
    /**
    
     * A function that is executed when a series point is selected or selection is canceled.
    
    
     */
    onPointSelectionChanged;
    /**
    
     * A function that is executed when a tooltip becomes hidden.
    
    
     */
    onTooltipHidden;
    /**
    
     * A function that is executed when a tooltip appears.
    
    
     */
    onTooltipShown;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    adaptiveLayoutChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    animationChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    annotationsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    centerTemplateChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    commonAnnotationSettingsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    commonSeriesSettingsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    customizeAnnotationChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    customizeLabelChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    customizePointChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    dataSourceChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    diameterChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    disabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    elementAttrChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    exportChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    innerRadiusChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    legendChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    loadingIndicatorChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    marginChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    minDiameterChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    paletteChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    paletteExtensionModeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pathModifiedChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    pointSelectionModeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    redrawOnResizeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    resolveLabelOverlappingChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    rtlEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    segmentsDirectionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    seriesChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    seriesTemplateChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    sizeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    sizeGroupChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    startAngleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    themeChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    titleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    tooltipChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    typeChange;
    constructor(elementRef, ngZone, templateHost, _watcherHelper, _idh, optionHost, transferState, platformId) {
      super(elementRef, ngZone, templateHost, _watcherHelper, transferState, platformId);
      this._watcherHelper = _watcherHelper;
      this._idh = _idh;
      this._createEventEmitters([{
        subscribe: 'disposing',
        emit: 'onDisposing'
      }, {
        subscribe: 'done',
        emit: 'onDone'
      }, {
        subscribe: 'drawn',
        emit: 'onDrawn'
      }, {
        subscribe: 'exported',
        emit: 'onExported'
      }, {
        subscribe: 'exporting',
        emit: 'onExporting'
      }, {
        subscribe: 'fileSaving',
        emit: 'onFileSaving'
      }, {
        subscribe: 'incidentOccurred',
        emit: 'onIncidentOccurred'
      }, {
        subscribe: 'initialized',
        emit: 'onInitialized'
      }, {
        subscribe: 'legendClick',
        emit: 'onLegendClick'
      }, {
        subscribe: 'optionChanged',
        emit: 'onOptionChanged'
      }, {
        subscribe: 'pointClick',
        emit: 'onPointClick'
      }, {
        subscribe: 'pointHoverChanged',
        emit: 'onPointHoverChanged'
      }, {
        subscribe: 'pointSelectionChanged',
        emit: 'onPointSelectionChanged'
      }, {
        subscribe: 'tooltipHidden',
        emit: 'onTooltipHidden'
      }, {
        subscribe: 'tooltipShown',
        emit: 'onTooltipShown'
      }, {
        emit: 'adaptiveLayoutChange'
      }, {
        emit: 'animationChange'
      }, {
        emit: 'annotationsChange'
      }, {
        emit: 'centerTemplateChange'
      }, {
        emit: 'commonAnnotationSettingsChange'
      }, {
        emit: 'commonSeriesSettingsChange'
      }, {
        emit: 'customizeAnnotationChange'
      }, {
        emit: 'customizeLabelChange'
      }, {
        emit: 'customizePointChange'
      }, {
        emit: 'dataSourceChange'
      }, {
        emit: 'diameterChange'
      }, {
        emit: 'disabledChange'
      }, {
        emit: 'elementAttrChange'
      }, {
        emit: 'exportChange'
      }, {
        emit: 'innerRadiusChange'
      }, {
        emit: 'legendChange'
      }, {
        emit: 'loadingIndicatorChange'
      }, {
        emit: 'marginChange'
      }, {
        emit: 'minDiameterChange'
      }, {
        emit: 'paletteChange'
      }, {
        emit: 'paletteExtensionModeChange'
      }, {
        emit: 'pathModifiedChange'
      }, {
        emit: 'pointSelectionModeChange'
      }, {
        emit: 'redrawOnResizeChange'
      }, {
        emit: 'resolveLabelOverlappingChange'
      }, {
        emit: 'rtlEnabledChange'
      }, {
        emit: 'segmentsDirectionChange'
      }, {
        emit: 'seriesChange'
      }, {
        emit: 'seriesTemplateChange'
      }, {
        emit: 'sizeChange'
      }, {
        emit: 'sizeGroupChange'
      }, {
        emit: 'startAngleChange'
      }, {
        emit: 'themeChange'
      }, {
        emit: 'titleChange'
      }, {
        emit: 'tooltipChange'
      }, {
        emit: 'typeChange'
      }]);
      this._idh.setHost(this);
      optionHost.setHost(this);
    }
    _createInstance(element, options) {
      return new DxPieChart(element, options);
    }
    ngOnDestroy() {
      this._destroyWidget();
    }
    ngOnChanges(changes) {
      super.ngOnChanges(changes);
      this.setupChanges('annotations', changes);
      this.setupChanges('dataSource', changes);
      this.setupChanges('palette', changes);
      this.setupChanges('series', changes);
    }
    setupChanges(prop, changes) {
      if (!(prop in this._optionsToUpdate)) {
        this._idh.setup(prop, changes);
      }
    }
    ngDoCheck() {
      this._idh.doCheck('annotations');
      this._idh.doCheck('dataSource');
      this._idh.doCheck('palette');
      this._idh.doCheck('series');
      this._watcherHelper.checkWatchers();
      super.ngDoCheck();
      super.clearChangedOptions();
    }
    _setOption(name, value) {
      let isSetup = this._idh.setupSingle(name, value);
      let isChanged = this._idh.getChanges(name, value) !== null;
      if (isSetup || isChanged) {
        super._setOption(name, value);
      }
    }
    /** @nocollapse */
    static ɵfac = function DxPieChartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxPieChartComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.DxTemplateHost), i0.ɵɵdirectiveInject(i1.WatcherHelper), i0.ɵɵdirectiveInject(i1.IterableDifferHelper), i0.ɵɵdirectiveInject(i1.NestedOptionHost), i0.ɵɵdirectiveInject(i0.TransferState), i0.ɵɵdirectiveInject(PLATFORM_ID));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxPieChartComponent,
      selectors: [["dx-pie-chart"]],
      contentQueries: function DxPieChartComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_annotations, 4);
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_series, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._annotationsContentChildren = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._seriesContentChildren = _t);
        }
      },
      hostAttrs: ["ngSkipHydration", "true"],
      inputs: {
        adaptiveLayout: "adaptiveLayout",
        animation: "animation",
        annotations: "annotations",
        centerTemplate: "centerTemplate",
        commonAnnotationSettings: "commonAnnotationSettings",
        commonSeriesSettings: "commonSeriesSettings",
        customizeAnnotation: "customizeAnnotation",
        customizeLabel: "customizeLabel",
        customizePoint: "customizePoint",
        dataSource: "dataSource",
        diameter: "diameter",
        disabled: "disabled",
        elementAttr: "elementAttr",
        export: "export",
        innerRadius: "innerRadius",
        legend: "legend",
        loadingIndicator: "loadingIndicator",
        margin: "margin",
        minDiameter: "minDiameter",
        palette: "palette",
        paletteExtensionMode: "paletteExtensionMode",
        pathModified: "pathModified",
        pointSelectionMode: "pointSelectionMode",
        redrawOnResize: "redrawOnResize",
        resolveLabelOverlapping: "resolveLabelOverlapping",
        rtlEnabled: "rtlEnabled",
        segmentsDirection: "segmentsDirection",
        series: "series",
        seriesTemplate: "seriesTemplate",
        size: "size",
        sizeGroup: "sizeGroup",
        startAngle: "startAngle",
        theme: "theme",
        title: "title",
        tooltip: "tooltip",
        type: "type"
      },
      outputs: {
        onDisposing: "onDisposing",
        onDone: "onDone",
        onDrawn: "onDrawn",
        onExported: "onExported",
        onExporting: "onExporting",
        onFileSaving: "onFileSaving",
        onIncidentOccurred: "onIncidentOccurred",
        onInitialized: "onInitialized",
        onLegendClick: "onLegendClick",
        onOptionChanged: "onOptionChanged",
        onPointClick: "onPointClick",
        onPointHoverChanged: "onPointHoverChanged",
        onPointSelectionChanged: "onPointSelectionChanged",
        onTooltipHidden: "onTooltipHidden",
        onTooltipShown: "onTooltipShown",
        adaptiveLayoutChange: "adaptiveLayoutChange",
        animationChange: "animationChange",
        annotationsChange: "annotationsChange",
        centerTemplateChange: "centerTemplateChange",
        commonAnnotationSettingsChange: "commonAnnotationSettingsChange",
        commonSeriesSettingsChange: "commonSeriesSettingsChange",
        customizeAnnotationChange: "customizeAnnotationChange",
        customizeLabelChange: "customizeLabelChange",
        customizePointChange: "customizePointChange",
        dataSourceChange: "dataSourceChange",
        diameterChange: "diameterChange",
        disabledChange: "disabledChange",
        elementAttrChange: "elementAttrChange",
        exportChange: "exportChange",
        innerRadiusChange: "innerRadiusChange",
        legendChange: "legendChange",
        loadingIndicatorChange: "loadingIndicatorChange",
        marginChange: "marginChange",
        minDiameterChange: "minDiameterChange",
        paletteChange: "paletteChange",
        paletteExtensionModeChange: "paletteExtensionModeChange",
        pathModifiedChange: "pathModifiedChange",
        pointSelectionModeChange: "pointSelectionModeChange",
        redrawOnResizeChange: "redrawOnResizeChange",
        resolveLabelOverlappingChange: "resolveLabelOverlappingChange",
        rtlEnabledChange: "rtlEnabledChange",
        segmentsDirectionChange: "segmentsDirectionChange",
        seriesChange: "seriesChange",
        seriesTemplateChange: "seriesTemplateChange",
        sizeChange: "sizeChange",
        sizeGroupChange: "sizeGroupChange",
        startAngleChange: "startAngleChange",
        themeChange: "themeChange",
        titleChange: "titleChange",
        tooltipChange: "tooltipChange",
        typeChange: "typeChange"
      },
      features: [i0.ɵɵProvidersFeature([DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      decls: 0,
      vars: 0,
      template: function DxPieChartComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxPieChartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxPieChartModule = /*#__PURE__*/(() => {
  class DxPieChartModule {
    /** @nocollapse */static ɵfac = function DxPieChartModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxPieChartModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxPieChartModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxPieChartComponent, DxoAdaptiveLayoutModule, DxoAnimationModule, DxiAnnotationModule, DxoBorderModule, DxoFontModule, DxoImageModule, DxoShadowModule, DxoCommonAnnotationSettingsModule, DxoCommonSeriesSettingsModule, DxoColorModule, DxoHoverStyleModule, DxoHatchingModule, DxoLabelModule, DxoArgumentFormatModule, DxoConnectorModule, DxoFormatModule, DxoSelectionStyleModule, DxoSmallValuesGroupingModule, DxoExportModule, DxoLegendModule, DxoMarginModule, DxoTitleModule, DxoSubtitleModule, DxoLoadingIndicatorModule, DxiSeriesModule, DxoSeriesTemplateModule, DxoSizeModule, DxoTooltipModule, DxoPieChartAdaptiveLayoutModule, DxoPieChartAnimationModule, DxiPieChartAnnotationModule, DxoPieChartAnnotationBorderModule, DxoPieChartArgumentFormatModule, DxoPieChartBorderModule, DxoPieChartColorModule, DxoPieChartCommonAnnotationSettingsModule, DxoPieChartCommonSeriesSettingsModule, DxoPieChartConnectorModule, DxoPieChartExportModule, DxoPieChartFontModule, DxoPieChartFormatModule, DxoPieChartHatchingModule, DxoPieChartHoverStyleModule, DxoPieChartImageModule, DxoPieChartLabelModule, DxoPieChartLegendModule, DxoPieChartLegendTitleModule, DxoPieChartLegendTitleSubtitleModule, DxoPieChartLoadingIndicatorModule, DxoPieChartMarginModule, DxoPieChartPieChartTitleModule, DxoPieChartPieChartTitleSubtitleModule, DxoPieChartSelectionStyleModule, DxiPieChartSeriesModule, DxoPieChartSeriesBorderModule, DxoPieChartSeriesTemplateModule, DxoPieChartShadowModule, DxoPieChartSizeModule, DxoPieChartSmallValuesGroupingModule, DxoPieChartSubtitleModule, DxoPieChartTitleModule, DxoPieChartTooltipModule, DxoPieChartTooltipBorderModule, DxIntegrationModule, DxTemplateModule, DxoAdaptiveLayoutModule, DxoAnimationModule, DxiAnnotationModule, DxoBorderModule, DxoFontModule, DxoImageModule, DxoShadowModule, DxoCommonAnnotationSettingsModule, DxoCommonSeriesSettingsModule, DxoColorModule, DxoHoverStyleModule, DxoHatchingModule, DxoLabelModule, DxoArgumentFormatModule, DxoConnectorModule, DxoFormatModule, DxoSelectionStyleModule, DxoSmallValuesGroupingModule, DxoExportModule, DxoLegendModule, DxoMarginModule, DxoTitleModule, DxoSubtitleModule, DxoLoadingIndicatorModule, DxiSeriesModule, DxoSeriesTemplateModule, DxoSizeModule, DxoTooltipModule, DxoPieChartAdaptiveLayoutModule, DxoPieChartAnimationModule, DxiPieChartAnnotationModule, DxoPieChartAnnotationBorderModule, DxoPieChartArgumentFormatModule, DxoPieChartBorderModule, DxoPieChartColorModule, DxoPieChartCommonAnnotationSettingsModule, DxoPieChartCommonSeriesSettingsModule, DxoPieChartConnectorModule, DxoPieChartExportModule, DxoPieChartFontModule, DxoPieChartFormatModule, DxoPieChartHatchingModule, DxoPieChartHoverStyleModule, DxoPieChartImageModule, DxoPieChartLabelModule, DxoPieChartLegendModule, DxoPieChartLegendTitleModule, DxoPieChartLegendTitleSubtitleModule, DxoPieChartLoadingIndicatorModule, DxoPieChartMarginModule, DxoPieChartPieChartTitleModule, DxoPieChartPieChartTitleSubtitleModule, DxoPieChartSelectionStyleModule, DxiPieChartSeriesModule, DxoPieChartSeriesBorderModule, DxoPieChartSeriesTemplateModule, DxoPieChartShadowModule, DxoPieChartSizeModule, DxoPieChartSmallValuesGroupingModule, DxoPieChartSubtitleModule, DxoPieChartTitleModule, DxoPieChartTooltipModule, DxoPieChartTooltipBorderModule, DxTemplateModule]
    });
  }
  return DxPieChartModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DxPieChartComponent, DxPieChartModule };
